export const PRODUCT_KEY_NAME_MAPPING = {
    IP4: "IP4",
    IP5: "IP5",
    IP5MVA: "IP5 MVA",
    IP7: "IP7",
    INDEX_ACHIEVER: "INDEX ACHIEVER",
    INDEX_ACHIEVER_ADVISORY: "INDEX ACHIEVER ADVISORY"
}

export const ASSET_NAME_MAPPING = {
    "FIA_S&P 500": "FIA_SP500",
    "FIA_iShares U.S. Real Estate": "FIA_REAL_ESTATE",
    "FIA_iShares MSCI EAFE ETF point-to-point with cap": "FIA_EAFE",
    "RILA_S&P 500": "RILA_SP500",
    "RILA_iShares U.S. Real Estate ETF": "RILA_REAL_ESTATE",
    "RILA_iShares MSCI EAFE ETF": "RILA_EAFE",
    "RILA_SPDR Gold Shares ETF": "RILA_SPDR",
}

export const PRODUCT_ITEM_NAME_MAPPING = {
    sp500: "S&P 500",
    yir: "iShares U.S. Real Estate",
    efa: "iShares MSCI EAFE ETF point-to-point with cap",
    retireeSpending: "S&P U.S. Retiree",
    riskControl: "S&P 500 Risk Control",
    barclay: "First Trust Barclays Edge Index 1-year point-to-point with cap",
    sp500Minus10Percentage: "S&P 500® 1-Year -10% Floor with Cap",
    sp500OneYear50Percentage: "S&P 500® 1-Year 50% Downside Participation Rate with Upside Participation Rate",
    sp500OneYear10Percentage: "S&P 500® 1-Year 10% Buffer with Cap",
    sp500SixYear10Percentage: "S&P 500® 6-Year 10% Buffer with Upside Participation Rate",
    eafeOneYear50Percenpage: "iShares MSCI EAFE ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate",
    eafeOneYear10Percenpage: "iShares MSCI EAFE ETF 1-Year 10% Buffer with Cap",
    realEstateOneYear50Percentage: "iShares U.S. Real Estate ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate",
    realEstateOneYear10Percentage: "iShares U.S. Real Estate ETF 1-Year 10% Buffer with Cap",
    spdrOneYear50Percentage: "SPDR Gold Shares ETF 1-Year 50% Downside Participation Rate",
    spdrOneYear10Percentage: "SPDR Gold Shares ETF 1-Year 10% Buffer with Cap"
}



// WEBPACK FOOTER //
// ./src/shared/constant.js